<template>
  <PasswordResetSteps
    :steps="steps"
    image="img/app-animation.gif"
  />
</template>

<script>
import PasswordResetSteps from 'client/components/PasswordResetSteps.vue';

export default {
  name: 'MacPasswordReset',

  components: {
    PasswordResetSteps,
  },

  data() {
    return {
      steps: [
        {
          step: 1,
          text: 'Click the menu bar app',
        },
        {
          step: 2,
          text: 'Fill in password fields*',
        },
        {
          step: 3,
          text: 'Click "Save"',
        },
      ],
    };
  },
};
</script>
